// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-box[data-v-53c47306] {\n  border-top: 6px solid #f6f7f9;\n}\n.title-tips[data-v-53c47306] {\n  height: 38px;\n  line-height: 38px;\n  color: #999;\n  font-size: 12px;\n}\n.title-bar[data-v-53c47306] {\n  padding: 20px 0 0 15px;\n  color: #333333;\n  font-size: 14px;\n  font-family: PingFang SC-Regular, PingFang SC;\n  font-weight: 400;\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
